/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Possible states an account verification can be in.
 *
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export const AccountVerificationStatus = {
  Unverified: "unverified",
  Pending: "pending",
  Resubmit: "resubmit",
  Review: "review",
  Verified: "verified",
  Failed: "failed",
} as const;
/**
 * Possible states an account verification can be in.
 *
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export type AccountVerificationStatus = ClosedEnum<
  typeof AccountVerificationStatus
>;

/** @internal */
export const AccountVerificationStatus$inboundSchema: z.ZodNativeEnum<
  typeof AccountVerificationStatus
> = z.nativeEnum(AccountVerificationStatus);
/** @internal */
export const AccountVerificationStatus$outboundSchema: z.ZodNativeEnum<
  typeof AccountVerificationStatus
> = AccountVerificationStatus$inboundSchema;
